<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEnvelope, faBell, faCaretDown, faSignOutAlt, faCog, faHistory, faStar, faCreditCard, faUserAlt, faBuilding,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faEnvelope, faBell, faCaretDown, faSignOutAlt, faCog, faHistory, faStar, faCreditCard, faUserAlt,
  faBuilding,
);

export default {
  name: 'ComponentsHeader',
  data () {
    return {
      isUserMenuOpen: false,
      searchQuery: null,
      timeout: null,
    };
  },
  computed: {
    ...mapState('ui', ['search']),
    ...mapGetters('administrator/me', ['fullName']),
    routerParams() {
      const params = {
        name: this.search.route,
      };

      if (this.searchQuery.length > 0) {
        params.query = {
          q: this.searchQuery,
        };
      }

      return params;
    },
    query() {
      const { query } = this.$route;
      return query.q || null;
    },
  },
  methods: {
    ...mapActions('administrator/me', [
      'logout',
    ]),
    onSearch(e) {
      // Enter
      if (e.which === 13 && this.searchQuery.length > 2) {
        clearTimeout(this.timeout);
        this.timeout = null;
        this.$router.push(this.routerParams);
        return;
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.timeout = setTimeout(() => {
        this.$router.push(this.routerParams);
      }, 1000);
    },
  },
  created() {
    if (this.query) {
      this.searchQuery = this.query;
    }
  },
}
</script>
<template>
  <header class="d-flex justify-content-between align-items-center">
    <div class="search flex-1">
      <input class="form-control rounded-0" name="search" autocomplete="off" v-model="searchQuery" :placeholder="search.placeholder" @keydown="onSearch" />
    </div>
    <ul class="d-flex align-items-center">
      <li class="ml-1">
        <a class="pointer d-flex align-items-center" @click="isUserMenuOpen = !isUserMenuOpen">
          <figure class="mr-2">
            <img
              :src="`https://ui-avatars.com/api/?rounded=true&size=128&name=${fullName}`"
              :alt="`${fullName}'s avatar`"
            />
          </figure>
          {{ fullName }}
          <font-awesome-icon icon="caret-down" class="ml-2" />
        </a>
        <ul class="user-menu" :class="{ open: isUserMenuOpen }" @click="isUserMenuOpen = !isUserMenuOpen">
          <li>
            <router-link :to="{ name: 'my-profile' }">
              <font-awesome-icon icon="user-alt" />
              <span>My Profile</span>
            </router-link>
          </li>
          <li></li>
          <li>
            <a class="pointer" @click="logout">
              <font-awesome-icon icon="sign-out-alt" />
              <span>Logout</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </header>
</template>
